import { render, staticRenderFns } from "./share-count-stat.vue?vue&type=template&id=3d5ddb6c&scoped=true&"
import script from "./share-count-stat.vue?vue&type=script&lang=js&"
export * from "./share-count-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5ddb6c",
  null
  
)

export default component.exports